<template>
  <div>
    <loading-view :isCardActive="loadingView" />
    <error-loading-view :isCardActive="errorLoadingView" @retry="loadTask" @hideView="errorLoadingView = false" />
    <div v-if="$siteTypeId() != 1">
      <vx-card title="Outcomes and Unit standards" class="mb-4">
        <div class="vx-row vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
          
          <div v-if="outcome" class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
            <h4>Outcome</h4>
            <table >
              <tr><td><p>Name:</p></td><td><p style="font-weight: 700">{{outcome.name}}</p></td></tr>
              <tr><td><p>Description:</p></td><td><p style="font-weight: 700">{{outcome.description}}</p></td></tr>
            </table>
          </div>
          <div v-else>
            <h4>Outcome</h4>
            <p style="font-weight: 700">N/A</p>
          </div>
          
          <div  v-if="standard" class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
            <h4>Unit Standard</h4>
              <table>
                <tr><td><p>Name:</p></td><td><p style="font-weight: 700">{{standard.name}}</p></td></tr>
                <tr><td><p>Description:</p></td><td><p style="font-weight: 700">{{standard.description}}</p></td></tr>
              </table>
          </div>
          <div v-else>
            <h4>Unit Standard</h4>
            <p style="font-weight: 700">N/A</p>
          </div>
        </div>
      </vx-card>
    </div>
    <div v-if="taskResults && !taskResults.quizId && !taskResults.uploadTaskId && !taskResults.videoCaptureTaskId">
      <div class="mb-3" v-for="(result, index) in taskResults.questions" :key="index">
        <div v-if="index == 0">
          <ispring-quiz-info-view :studentName="taskResults.fullname" :isCardActive="ispringQuizInfoView" :quizInfo="taskResults" :newScore="ispringTotalScore" />
        </div>
        <div v-if="result.questionType == 'MultipleChoice'">
          <multiple-choice-question :isCardActive="multipleChoiceQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'MultipleResponse'">
          <multiple-response-question :isCardActive="multipleResponseQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'Text'">
          <text-question :isCardActive="textQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'Sequence'">
          <sequence-question :isCardActive="sequenceQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'Matching'">
          <matching-question :isCardActive="matchingQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'Sentence' || result.questionType == 'MultipleChoiceText' || result.questionType == 'WordBank'">
          <sentence-question :isCardActive="sentenceQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'LikertScale'">
          <likert-scale-question :isCardActive="likertScaleQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
      </div>
    </div>
    <div v-else-if="taskResults && taskResults.quizId">
      <div v-for="(answer, answerIndex) in taskResults.answers" :key="answerIndex">
        <div v-if="answerIndex == 0">
          <quiz-info-view :studentName="taskResults.fullname"  :isCardActive="quizInfoView" :quiz="taskResults.quizDetails" :info="taskResults" :newScore="quizAchievedMarks" :freeTextTotal="quizTotalMarks" :newQuizTotal="quizTotalMarks" />
        </div>
        <div v-if="answer.questionType == 1"> <!-- MultipleChoiceSingleAnswer -->
          <mcss-question :isCardActive="mcssQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 2"> <!-- MultipleChoiceMultipleAnswers -->
          <mcms-question :isCardActive="mcmsQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 3"> <!-- FreeText -->
          <free-text-question :isCardActive="freeTextQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 4"> <!-- Table -->
          <table-question :isCardActive="tableQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 5"> <!-- Drag And Drop -->
          <drag-and-drop :isCardActive="dragAndDropQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 6"> <!-- Upload -->
          <upload-question :isCardActive="uploadQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
      </div>
    </div>
    <div v-else-if="taskResults && taskResults.uploadTaskId">
      <upload-task-view :isCardActive="uploadTaskView" :uploadTask="taskResults" />
    </div>
    <div v-else-if="taskResults && taskResults.videoCaptureTaskId">
      <capture-task-view :isCardActive="captureTaskView" :captureTask="taskResults" />
    </div>
    <div>
      <snapshot-view :isCardActive="snapshotView && !(loadingView || errorLoadingView) && !(taskResults.uploadTaskId || taskResults.videoCaptureTaskId)" />
      <ispring-final-comment-view v-if="taskResults && !taskResults.quizId && !taskResults.uploadTaskId && !taskResults.videoCaptureTaskId" :isCardActive="ispringFinalCommentView && !(loadingView || errorLoadingView)" :totalScore="ispringTotalScore" :quizData="taskResults" :predefinedComments="predefinedComments" />
      <quiz-final-comment-view v-else-if="taskResults && taskResults.quizId" :isCardActive="quizFinalCommentView && !(loadingView || errorLoadingView)" :quizAchievedMarks="quizAchievedMarks" :quizInfo="taskResults" :quizTextTotal="quizTotalMarks" :predefinedComments="predefinedComments" :newQuizTotal="quizTotalMarks" />
      <upload-comment-view v-else-if="taskResults && taskResults.uploadTaskId" :isCardActive="uploadCommentView && !(loadingView || errorLoadingView)" :uploadTask="taskResults" :predefinedComments="predefinedComments" />
      <capture-comment-view v-else-if="taskResults && taskResults.videoCaptureTaskId" :isCardActive="captureCommentView && !(loadingView || errorLoadingView)" :captureTask="taskResults" :predefinedComments="predefinedComments" />
    </div>

    <div v-if="taskResults.length != 0" class="vx-row">
      <vs-spacer></vs-spacer>
      <div id="buttons-container" class="vx-col">
        <vs-button v-if="buttonsAvaiable(taskResults.statusId)" color="danger" class="mr-3 vs-con-loading__container" ref="queryAssessmentButton" @click="queryAssessment">Query <span v-if="showAssessmentLabel(taskResults.statusId)">Assessment</span><span v-if="showModerationLabel(taskResults.statusId)">Moderation</span></vs-button>
        <vs-button v-if="buttonsAvaiable(taskResults.statusId)" color="success" class="mr-3 vs-con-loading__container" ref="acceptAssessmentButton" @click="acceptAssessment">Accept <span v-if="showAssessmentLabel(taskResults.statusId)">Assessment</span><span v-if="showModerationLabel(taskResults.statusId)">Moderation</span></vs-button>
        <vs-button color="warning" type="border" class="mb-2" @click="closeTab">Close</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import ispringQuizInfoView from "./evaluationviews/iSpringQuizInfoView.vue";
import multipleChoiceQuestion from "./evaluationviews/MultipleChoiceQuestion.vue";
import multipleResponseQuestion from "./evaluationviews/MultipleResponseQuestion.vue";
import textQuestion from "./evaluationviews/TextQuestion.vue";
import sequenceQuestion from "./evaluationviews/SequenceQuestion.vue";
import matchingQuestion from "./evaluationviews/MatchingQuestion.vue";
import sentenceQuestion from "./evaluationviews/SentenceQuestion.vue";
import likertScaleQuestion from "./evaluationviews/LikertScaleQuestion.vue";
import quizInfoView from "./evaluationviews/QuizInfoView.vue";
import mcssQuestion from "./evaluationviews/MCSSQuestion.vue";
import mcmsQuestion from "./evaluationviews/MCMSQuestion.vue";
import freeTextQuestion from "./evaluationviews/FreeTextQuestion.vue";
import dragAndDrop from "./evaluationviews/DragAndDrop.vue";
import uploadQuestion from "./evaluationviews/UploadQuestion.vue";
import tableQuestion from "./evaluationviews/TableQuestion.vue";
import uploadTaskView from "../assessor/assessmentviews/UploadTaskView.vue";
import captureTaskView from "../assessor/assessmentviews/CaptureTaskView.vue";
import snapshotView from "../assessor/assessmentviews/SnapshotsView.vue";
import loadingView from "../assessor/assessmentviews/ResultsLoadingView.vue";
import errorLoadingView from "../assessor/assessmentviews/ErrorLoadingView.vue";
import ispringFinalCommentView from "./evaluationviews/iSpringFinalCommentView.vue";
import quizFinalCommentView from "./evaluationviews/QuizFinalCommentView.vue";
import uploadCommentView from "./evaluationviews/UploadCommentView.vue";
import captureCommentView from "./evaluationviews/CaptureCommentView.vue";

export default {
  components: {
    ispringQuizInfoView,
    multipleChoiceQuestion,
    multipleResponseQuestion,
    textQuestion,
    sequenceQuestion,
    matchingQuestion,
    sentenceQuestion,
    likertScaleQuestion,
    quizInfoView,
    mcssQuestion,
    mcmsQuestion,
    freeTextQuestion,
    uploadQuestion,
    tableQuestion,
    dragAndDrop,
    uploadTaskView,
    captureTaskView,
    snapshotView,
    loadingView,
    errorLoadingView,
    ispringFinalCommentView,
    quizFinalCommentView,
    uploadCommentView,
    captureCommentView
  },
  data() {
    return {
      isMounted: false,
      taskLogId: null,
      taskResults: [],
      ispringQuizInfoView: true,
      multipleChoiceQuestion: true,
      multipleResponseQuestion: true,
      textQuestion: true,
      sequenceQuestion: true,
      matchingQuestion: true,
      sentenceQuestion: true,
      likertScaleQuestion: true,
      quizInfoView: true,
      mcssQuestion: true,
      mcmsQuestion: true,
      freeTextQuestion: true,
      uploadQuestion:true,
      tableQuestion: true,
      dragAndDropQuestion: true,
      uploadTaskView: true,
      captureTaskView: true,
      snapshotView: true,
      loadingView: false,
      errorLoadingView: false,
      ispringFinalCommentView: true,
      quizFinalCommentView: true,
      ispringTotalScore: 0,
      quizAchievedMarks: 0,
      quizTotalMarks: 0,
      uploadCommentView: true,
      captureCommentView: true,
      predefinedComments: [],
      outcome:[],
      standard:[]
    };
  },
  watch: {
    taskResults: {
      deep: true,
      handler() {
        var self = this;
        if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId){
          self.ispringTotalScore = 0;
          for(var i = 0; i < self.taskResults.questions.length; i++) {
            self.ispringTotalScore += parseInt(self.taskResults.questions[i].assessment.awardedPoints)
          }
        }
        else if(self.taskResults && self.taskResults.quizId){
          self.quizAchievedMarks = 0;
          self.quizTotalMarks = 0;
          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizAchievedMarks += self.taskResults.answers[i].questionAchievedMarks == "" ? 0 : parseInt(self.taskResults.answers[i].questionAchievedMarks)
          }

          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizTotalMarks += parseInt(self.taskResults.answers[i].questionTotalMarks)
          }

          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizTotalMarks += parseInt(self.taskResults.answers[i].textOriginalTotalPoints)
          }

          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizTotalMarks += parseInt(self.taskResults.answers[i].tableOriginalTotalPoints)
          }
        }
      }
    }
  },
  computed: {

  },
  methods: {
    closeTab() {
      this.close();
    },
    close() {
      if(window.opener){
        var btn = window.opener.document.getElementById("refresh-btn");
        if (btn) {
          btn.click();
        }
      }
      window.open("", "_self").close();
    },
    initValues() {
      this.isMounted = false;
      this.taskLogId = null;
      this.taskResults = [];
      this.errors.clear();
    },
    loadPredefinedComments(){
      const self = this;

      var onSuccess = function (response) {
        self.predefinedComments = response.data.map((item) => {return {label: item.text, value: item.value} });
      };

      self.$ajaxGet(self, "PredefinedComment/GetSelectList", onSuccess);
    },
    loadTask() {
      const self = this;
      self.loadingView = true;

      var onSuccess = function(response) {
        if (response.data) {
          self.taskResults = response.data;
        }
      };

      var onFinally = function() {
        self.loadingView = false;
        if (!self.loadingView && self.taskResults.length == 0)
          self.errorLoadingView = true;
      };

      self.$ajaxGet(self, "evaluator/GetTask/" + self.$route.query.TaskLogId, onSuccess, onFinally);
    },
    acceptAssessment() {
      var self = this;
      self.showLoadingOnElement("acceptAssessmentButton", 0.45, "material");

      var onSuccess = response => {
        self.$vs.loading.close(self.$refs.acceptAssessmentButton.$el);
        self.closeTab();
      };

      var evaluationResult = {};
      evaluationResult.logId = self.$route.query.TaskLogId;

      if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId) {
        evaluationResult.assessment = self.taskResults.questions.map(function(item) {return item.assessment});
        evaluationResult.finalEvaluatorComment = self.taskResults.finalEvaluatorComment;

        self.$ajaxPost(self, "ISpringQuizAssessment/AcceptedByEvaluator", evaluationResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.quizId) {
        evaluationResult.quizId = self.taskResults.quizId;
        evaluationResult.quizAnswers = self.taskResults.answers;
        evaluationResult.finalEvaluatorComment = self.taskResults.finalEvaluatorComment;

        self.$ajaxPost(self, "QuizAssessment/AcceptedByEvaluator", evaluationResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.uploadTaskId) {
        evaluationResult.evaluatorComment = self.taskResults.evaluatorComment;

        self.$ajaxPost(self, "UploadAssessment/AcceptedByEvaluator", evaluationResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.videoCaptureTaskId) {
        evaluationResult.evaluatorComment = self.taskResults.evaluatorComment;

        self.$ajaxPost(self, "CaptureAssessment/AcceptedByEvaluator", evaluationResult, onSuccess);
      }
    },
    queryAssessment() {
      var self = this;
      self.showLoadingOnElement("queryAssessmentButton", 0.45, "material");

      var onSuccess = response => {
        self.$vs.loading.close(self.$refs.queryAssessmentButton.$el);
        self.closeTab();
      };

      var evaluationResult = {};
      evaluationResult.logId = self.$route.query.TaskLogId;

      if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId) {
        evaluationResult.assessment = self.taskResults.questions.map(function(item) {return item.assessment});
        evaluationResult.finalEvaluatorComment = self.taskResults.finalEvaluatorComment;

        self.$ajaxPost(self, "ISpringQuizAssessment/QueryByEvaluator", evaluationResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.quizId) {
        evaluationResult.quizId = self.taskResults.quizId;
        evaluationResult.quizAnswers = self.taskResults.answers;
        evaluationResult.finalEvaluatorComment = self.taskResults.finalEvaluatorComment;

        self.$ajaxPost(self, "QuizAssessment/QueryByEvaluator", evaluationResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.uploadTaskId) {
        evaluationResult.evaluatorComment = self.taskResults.evaluatorComment;

        self.$ajaxPost(self, "UploadAssessment/QueryByEvaluator", evaluationResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.videoCaptureTaskId) {
        evaluationResult.evaluatorComment = self.taskResults.evaluatorComment;

        self.$ajaxPost(self, "CaptureAssessment/QueryByEvaluator", evaluationResult, onSuccess);
      }
    },
    scrollToNavbar() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -500,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
    },
    showLoadingOnElement(element, scale, type){
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    buttonsAvaiable(taskStatusId){
      switch (taskStatusId) {
        case 3:
          return true;
          break;
        case 18:
          return true;
          break;
        case 20:
          return true;
          break;
        default:
          return false;
          break;
      }
    },
    showAssessmentLabel(statusId){
      if(statusId === 2 || statusId === 16)
        return true;

      return false;
    },
    showModerationLabel(statusId){
      if(statusId === 3 || statusId === 20)
        return true;

      return false;
    },
    getStandardsAndOutcomes(){
      var self = this;
      var onSuccess = response =>{
        self.standard = response.data.standard;
        self.outcome = response.data.outcome;
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_Page){
        }
      }
      //self.$route.query.TaskLogId
      self.$ajaxGet(self, "Course/GetOutcomeInfo/" + self.$route.query.TaskLogId , onSuccess, onFinally);
    },
  },
  mounted() {
    var self = this;
    self.loadTask();
    self.loadPredefinedComments();
    self.getStandardsAndOutcomes();
    self.isMounted = true;
  }
}
</script>
<style>
@media screen and (max-width: 644px) {
  #buttons-container {
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
